// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-advanced-faculty {
  align-items: flex-start;
  margin-bottom: 40px;
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.search-advanced-faculty .search-section {
  width: 100%;
  display: flex;
}
.search-advanced-faculty .search-section .search-bar {
  width: 60%;
  margin-right: 30px;
  height: 40px;
}
.search-advanced-faculty .search-section .advanced-search-button {
  height: 40px;
  background: var(--benchmarking-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  cursor: pointer;
  color: white;
  border-radius: 10px;
  padding: 0 10px;
}
.search-advanced-faculty .search-section .advanced-search-button p {
  white-space: nowrap;
}
.search-advanced-faculty .filters-search-modal {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}
.search-advanced-faculty .filters-search-modal .group-filters {
  display: flex;
  margin-right: 20px;
  align-items: center;
  font-size: 14px;
}

.ant-modal-content .title-search-advance {
  font-size: 26px;
}
.ant-modal-content .sub-title-search-advance {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px !important;
}
.ant-modal-content .affilication {
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/SearchAdvanceFaculty.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACF;AAAE;EACE,WAAA;EACA,aAAA;AAEJ;AADI;EACE,UAAA;EACA,kBAAA;EACA,YAAA;AAGN;AADI;EACE,YAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAGN;AAFM;EACE,mBAAA;AAIR;AAAE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AAEJ;AADI;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAGN;;AAEE;EACE,eAAA;AACJ;AACE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AACJ;AACE;EACE,mBAAA;AACJ","sourcesContent":[".search-advanced-faculty {\n  align-items: flex-start;\n  margin-bottom: 40px;\n  width: 100%;\n  height: fit-content;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  .search-section {\n    width: 100%;\n    display: flex;\n    .search-bar {\n      width: 60%;\n      margin-right: 30px;\n      height: 40px;\n    }\n    .advanced-search-button {\n      height: 40px;\n      background: var(--benchmarking-color);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: 600;\n      cursor: pointer;\n      color: white;\n      border-radius: 10px;\n      padding: 0 10px;\n      p {\n        white-space: nowrap;\n      }\n    }\n  }\n  .filters-search-modal {\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 10px;\n    .group-filters {\n      display: flex;\n      margin-right: 20px;\n      align-items: center;\n      font-size: 14px;\n    }\n  }\n}\n.ant-modal-content {\n  .title-search-advance {\n    font-size: 26px;\n  }\n  .sub-title-search-advance {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 15px !important;\n  }\n  .affilication {\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
